export const imageImportActions = {
  Add: 0,
  Skip: 2
}

export const statusLabels = {
  Ready: 'Готово',
  Unmatched: 'Не найдено',
  Ambiguous: 'Неоднозначно',
  Duplicate: 'Дубликат',
  InvalidFile: 'Некорректный файл',
  InvalidImage: 'Некорректное изображение'
}

export const matchTypeLabels = {
  Article: 'Артикул',
  ModelCode: 'ModelCode',
  Manual: 'Вручную',
  None: 'Не определено'
}

export const actionLabels = {
  Add: 'Добавить',
  Skip: 'Пропустить',
  Conflict: 'Требуется решение'
}

export function statusLabel(status) {
  return statusLabels[status] || status || 'Неизвестно'
}

export function statusSeverity(status) {
  if (status === 'Ready') return 'success'
  if (status === 'InvalidFile' || status === 'InvalidImage') return 'danger'
  if (status === 'Unmatched' || status === 'Ambiguous' || status === 'Duplicate') return 'warn'
  return 'secondary'
}

export function diagnosticMessage(error) {
  const code = error?.raw?.error || error?.raw?.code || error?.error || ''
  const messages = {
    'IMAGE_IMPORT.REVISION_CONFLICT': 'Данные импорта изменились. Состояние обновлено — проверьте изменения ещё раз.',
    'IMAGE_IMPORT.SOURCE_NOT_FOUND': 'Исходный ZIP-файл больше недоступен.',
    'IMAGE_IMPORT.CONFIRMATION_INTEGRITY_FAILED': 'Подтверждённый план импорта не прошёл проверку целостности.',
    'IMAGE_IMPORT.DEFAULT_PRODUCT_CHANGED': 'Default Product у ProductType изменился. Проверьте план заново.',
    'IMAGE_IMPORT.NO_ENTRIES_TO_APPLY': 'Нет файлов для применения.',
    'IMAGE_IMPORT.APPLY_IN_PROGRESS': 'Импорт уже применяется.'
  }
  return messages[code] || error?.message || 'Не удалось выполнить операцию. Обновите данные и попробуйте снова.'
}

const diagnosticLabels = {
  'IMAGE_IMPORT.ENTRY_NOT_RESOLVED': 'Запись ещё не сопоставлена с товаром или не получила действие. Выберите цель либо пропустите файл.',
  'IMAGE_IMPORT.JOB_NOT_EDITABLE': 'Этот импорт уже нельзя изменять в текущем состоянии.',
  'IMAGE_IMPORT.TARGET_NOT_FOUND': 'Выбранный товар больше не найден в каталоге.',
  'IMAGE_IMPORT.TARGET_OTHER_BRAND': 'Выбранный товар относится к другому бренду.',
  'IMAGE_IMPORT.TARGET_IMAGE_STATE_INVALID': 'Текущее состояние изображений товара требует проверки.',
  'IMAGE_IMPORT.DEFAULT_PRODUCT_NOT_FOUND': 'Для выбранного типа товара не найден текущий default Product.',
  'IMAGE_IMPORT.DEFAULT_PRODUCT_CHANGED': 'Default Product у ProductType изменился. Проверьте выбор ещё раз.'
}

export function diagnosticLabel(diagnostic) {
  if (!diagnostic) return 'Неизвестная ошибка проверки.'
  return diagnosticLabels[diagnostic.code] || diagnostic.message || diagnostic.code || 'Неизвестная ошибка проверки.'
}
